export enum DrawerType {
    persistent = 'persistent',
    temporary = 'temporary',
}
